import React from 'react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-left">
          <img src="/bnbn.png" alt="Logo" className="footer-logo" />
        </div>
        <div className="footer-right">
          <p>📞 +34 627 052 819</p>
          <p>📞 +34 672 261 369</p>
          <p>✉️ Laurent.studios.uio@gmail.com</p>
        </div>
      </div>
    </footer>
  );
}
export default Footer;